
import { connect } from 'react-redux';

import Preloader from './Preloader';

let mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    title: state.vkui.appTitle,
});

const PreloaderContainer = connect(mapStateToProps)(Preloader);

export default PreloaderContainer;
